import { ModalWindow } from '@tblabs/truffle';
import { PlayerLogic } from './PlayerLogic';
import { SvgButton } from './SvgButton';
import { PlaylistProvider } from '../Services/PlaylistProvider';
import { FilesUploader } from './FilesUploader';


export class MenuWindow extends ModalWindow
{
    constructor(_logic: PlayerLogic, _playlistProvider: PlaylistProvider)
    {
        super("Menu", true, true, true);

        this.AddContent(
            new FilesUploader(_playlistProvider).WidthPercent(100)
                .OnUploadStarted(() => this.CloseWindow()),

            new SvgButton("Update current playlist").WidthPercent(100).MarginTop(8)
                .OnClick(async () =>
                {
                    await _logic.UpdateCurrentPlaylist();
                    this.CloseWindow();
                }),
            new SvgButton("Refresh all songs").WidthPercent(100).MarginTop(8)
                .OnClick(async () =>
                {
                    await _logic.LoadAllSongs();
                    this.CloseWindow();
                }),
            new SvgButton("Export selected songs to new playlist").WidthPercent(100).MarginTop(8)
                .OnClick(async () =>
                {
                    let name = prompt("Edit playlist name");
                    if (name)
                    {
                        name = name.replace(/[^a-zA-Z0-9]/gi, "_");
                        await _logic.ExportSelectedToNewPlaylist(name);
                        this.CloseWindow();
                    }
                }),
            new SvgButton("Edit current playlist name").WidthPercent(100).MarginTop(8)
                .OnClick(async () =>
                {
                    let name = prompt("Edit playlist name", _logic.CurrentPlaylist.object.Name);
                    if (name)
                    {
                        name = name.replace(/[^a-zA-Z0-9]/gi, "_");
                        _logic.CurrentPlaylist.object.Name = name;
                        await _playlistProvider.UpdatePlaylist(_logic.CurrentPlaylist.object);
                        this.CloseWindow();
                    }
                }),
        );

        this.AddToFooter(
            new SvgButton("Close").OnClick(() => this.CloseWindow())
        );

        this.ShowWindow();
    }
}
